import React from 'react';

const renderTabs = props => {
	return props.tabs.map(tab => {
		const disabled = (props.id == "primary" && props.selecteds[tab.id]  ? "disabled" : "");
		return(
			<li 
				data-position="bottom" 
				data-delay="50" 
				data-tooltip={tab.label} 
				className={`tab col tooltipped s${tab.size} ${disabled}`} 
				key={tab.id} 
				title={disabled ? "Formulário já respondido." : ""}
			>
				<a 
					href={`#${tab.id}`} 
					className={`${tab.className} ${disabled} ${props.selected == tab.id ? "active" : ""}`} 
					onClick={props.clickAction} 
				>
					{tab.label}
				</a>
			</li>
		);
	});
};

export const TabBar = props => {
	$(document).ready(() => $(`.tabs#${props.id}`).tabs({
		onShow: props.changeAction || function() {}
	}));
	return (
		<ul className="tabs tab-bar" id={props.id}>
			{renderTabs(props)}
		</ul>
	);
};


// WEBPACK FOOTER //
// src/molecules/lib/TabBar.js